export default {
    mounted: (el, binding) => {
        function loadImage() {
            const imageElement = Array.from(el.children).find((el) => el.nodeName === "IMG");
            if (imageElement) {
                imageElement.addEventListener("load", () => {
                    setTimeout(() => el.classList.add("loaded"), 100);
                });
                imageElement.addEventListener("error", () => console.log("error"));
                imageElement.src = imageElement.dataset.url;
            }
        }
        function load() {
            if (typeof binding.value === "function") {
                const result = binding.value(el);
                if (result instanceof Promise) {
                    result.then(() => el.classList.add("loaded"));
                }
                else {
                    el.classList.add("loaded");
                }
            }
            else {
                loadImage();
            }
        }
        function handleIntersect(entries, observer) {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }
                else {
                    load();
                    observer.unobserve(el);
                }
            });
        }
        function createObserver() {
            const options = {
                root: null,
                threshold: "0"
            };
            const observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
        }
        if (!window["IntersectionObserver"]) {
            load();
        }
        else {
            createObserver();
        }
    }
};
